<template>
  <div class="md-layout card-relatorio">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>attach_file</md-icon>
          </div>
          <h4 class="title">{{form.titulo}}</h4>
        </md-card-header>

        <md-card-content>
          <slot name="body">
            <div v-if="loading" class="md-layout">
              <div class="md-layout-item md-size-100 box-carregando">
                <md-progress-spinner
                  :md-diameter="40"
                  :md-stroke="4"
                  md-mode="indeterminate"
                >{{msg_status}}</md-progress-spinner>
              </div>
            </div>

            <div class="md-layout">
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">ID</label>
                <div class="md-form-text">{{form.id}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Título</label>
                <div class="md-form-text">{{form.titulo}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Arquivo</label>
                <div class="md-form-text">
                  <a :href="form.url" target="_blank">{{form.arquivo}}</a>
                </div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Cliente / Empresa</label>
                <div class="md-form-text">{{form.cliente}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Unidade</label>
                <div class="md-form-text">{{form.unidade}}</div>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Data Cadastro</label>
                <div class="md-form-text">{{form.data_cadastro | date_show}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Usuário Cadastro</label>
                <div class="md-form-text">{{form.usuario_cadastro}}</div>
              </div>
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100 mb-20">
                <label class="md-form-label">Observações</label>
                <div class="md-form-text">{{form.texto}}</div>
              </div>
            </div>

            <div class="md-layout flex-end group-btn-right">
              <div class="md-layout-item mb-20">
                <a :href="form.url" target="_blank" class="pull-right">
                  <md-button class="md-primary" type="button">
                    <md-icon>remove_red_eye</md-icon>Visualizar
                  </md-button>
                </a>
                <a
                  style="cursor:pointer"
                  class="pull-right"
                  v-on:click="my_download(form.url, form.arquivo)"
                  target="_blank"
                >
                  <md-button class="md-primary" type="button">
                    <md-icon>save_alt</md-icon>Baixar
                  </md-button>
                </a>
              </div>
            </div>
          </slot>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>


<style scoped>
@import "../../../assets/css/validate.css";
@import "../../../assets/css/form_custom.css";
</style>
<script>
import service from "../../../services/ArquivoClienteService";
import autocomplete from "../../../components/Rend/autocomplete";
import filelogo from "../../../components/Rend/filelogo";
import mixin_validator from "../../../library/mixin/validator";
import mixin_util from "../../../library/mixin/util";
import modal from "../../../components/Modal";
import Datepicker from "../../../components/Rend/vuejs-datepicker/src/components/Datepicker";
import ptBR from "../../../components/Rend/vuejs-datepicker/src/locale/translations/pt-BR";
import CardCadastro from "../../../components/CardCadastro";
import vue_select from "../../../components/Rend/vue-select/src/Select.vue";
import show_image from "../../../components/Rend/show-image/show.vue";
import toolbar from "../components/toolbar_visualizar.vue";
import swal from "sweetalert2";
import FileSaver from "file-saver";

export default {
  components: {
    autocomplete,
    filelogo,
    modal,
    Datepicker,
    CardCadastro,
    vue_select,
    show_image,
    toolbar
  },

  mixins: [mixin_util, mixin_validator],
  props: ["id_load", "show_back_button", "onBack", "onSave"],
  data() {
    return {
      acao: "Cadastrar",
      form: {},
      perfis: [],
      clientes: [],
      clientes_list: [],
      show_perfil: false,
      file_upload: null,
      botao_voltar_visible: true,
      loading: true,
      result2: "",
      disableButton: false,
      show_message: "off",
      message_text: "",
      message_type: "success",
      interval_message: null,
      showDialogError: false,
      msg_status: "Carregando",
      show_modal_contacts: false,
      show_sub_form: true,
      data: null,
      data_cadastro: null,
      language_date: ptBR,
      title: "Relatório de auditoria técnica",
      icone_title: "assignment"
    };
  },
  mounted() {
    let self = this;
    this.form = service.getModel();

    if (this.show_back_button != null && this.show_back_button != undefined) {
      this.botao_voltar_visible = this.show_back_button;
    }

    this.disableButton = true;

    if (
      this.cliente_oculto != null &&
      this.cliente_oculto != undefined &&
      this.cliente_oculto.toString() == "1"
    ) {
      data["cliente_oculto"] = this.cliente_oculto;
      this.title = "Auditoria Cliente Oculto";
      this.icone_title = "people_outline";
    }

    if (
      this.id_load != null &&
      this.id_load != undefined &&
      this.id_load != ""
    ) {
      service.getViewCompleta(this.id_load).then(function(response) {
        self.form = response.data;

        self.loading = false;
        self.disableButton = false;
      });
    } else {
      this.loading = false;
      this.disableButton = false;
    }

    this.$store.dispatch("setButtonBack", {
      in_form: true,
      rota: "inspecao",
      exibe: this.show_back_button,
      onBack: this.onBack
    });
    //this.$store.dispatch("user/save", this.tmpUser)
  },
  methods: {
    my_download(url, arquivo) {
      console.log("File saver? " + url);
      FileSaver.saveAs(url, arquivo);
    },
    botao_voltar() {
      var self = this;

      if (this.onBack != null && this.onBack != undefined) {
        this.onBack(self);
      }
    },
    changed(prop) {},

    onPreSaveContatos() {
      this.show_sub_form = false;
    },
    onPosSaveContatos(itens) {
      this.show_sub_form = true;
    },

    clear_message() {
      this.show_message = "off";
      clearInterval(this.interval_message);
    },
    hideModal() {
      this.showDialogError = false;
    },
    validar() {
      this.indicateAllErrors(); //Verifica todos os possíveis erros em tela.
      console.log("erros? ");
      console.log(this.p_validator.errors);

      if (this.p_validator.errors.length > 0) {
        this.showDialogError = true;
        return false;
      }

      return true;
    }
  }
};
</script>